// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';
import { installLessonSoundUnlock } from "./lib/learning/lessonSounds";

const theme = createTheme({
  typography: {
    // ✅ keep the inner double quotes for the CSS font-family value
    fontFamily: '"DM Sans", monospace',
  },
  palette: {
    primary: { main: '#E9652D' },
    secondary: { main: '#f3f4f6' },
    error: { main: '#E00' },
    success: { main: '#0CEE00' },
  },
});

installLessonSoundUnlock();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
// src/index.js (near bottom)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => console.error("SW registration failed", err));
  });
}
